interface IExpandIconProps {
  color?: string;
}

/**
 * Two arrows pushing apart, up-right and down-left: "take the whole screen".
 * Pairs with {@link CollapseIcon}, which mirrors it.
 */
export const ExpandIcon = ({ color = "#fff" }: IExpandIconProps) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 4H20V10M20 4L13 11M10 20H4V14M4 20L11 13"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
